import { Employee } from '../Employee';
import { HrisProvider } from '../../enums/IntegrationProvider/HrisProvider';
import { Countable, Paginatable } from '../Pagination';

export interface PipelineApplicationList extends Paginatable, Countable {
  applications: PipelineApplication[];
}

export enum ApplicationStatus {
  Draft = 'draft',
  Active = 'active',
  Rejected = 'rejected',
  Hired = 'hired',
}

export interface PipelineApplication {
  appliedAt: Date;
  candidate: PipelineApplicationCandidate;
  daysInCurrentJobStage: number;
  id: number;
  job: PipelineApplicationJob;
  jobStage: PipelineApplicationJobStage;
  stagePlanTemplateId: number;
  sendOfferPermitted: boolean;
  status: ApplicationStatus;
  totalPendingActions: number;
  allowedHrisProvider?: HrisProvider;
  resume?: PipelineApplicationResume;
  hrisEmployee?: Employee;
  nextInterviewStageId?: number;
  offerRequisitionId?: number;
  redacted: boolean;
}

interface PipelineApplicationCandidate {
  id: number;
  email: string;
  name: string;
}

export interface PipelineApplicationResume {
  id: number;
  url?: string;
}

interface PipelineApplicationJob {
  id: number;
  name: string;
  status: string;
}

interface PipelineApplicationJobStage {
  id: number;
  name: string;
}
